import type { Enum } from '@/types/Enum'
import type { BuyerType } from '@/types/federal-contract/Api'
import type { FederalContractSearchFilter } from '@/types/federal-contract/Filter'

export const NOTICE_TYPES: Array<string> = [
  'Combined Synopsis/Solicitation',
  'Presolicitation',
  'Sale of Surplus Property',
  'Solicitation',
  'Sources Sought',
  'Special Notice',
  'Award Notice',
]

export const DEFAULT_FEDERAL_CONTRACT_FILTER: FederalContractSearchFilter = {
  active_after: null,
  active_before: null,
  published_after: null,
  published_before: null,
  is_active: null,
  buyer_ids: [],
  naics_codes: [],
  notice_types: [...NOTICE_TYPES],
  psc_codes: [],
  set_aside_codes: [],
  solicitation_numbers: [],
}

export const removeAwardNoticeFromFederalContractScheduleFilters = (
  filters: FederalContractSearchFilter,
): FederalContractSearchFilter => {
  return {
    ...filters,
    notice_types: filters.notice_types.filter(
      (notice) => notice !== 'Award Notice',
    ),
  }
}

export const DEFAULT_FEDERAL_CONTRACT_FILTER_WITHOUT_AWARD_NOTICE =
  removeAwardNoticeFromFederalContractScheduleFilters(
    DEFAULT_FEDERAL_CONTRACT_FILTER,
  )

export const STATUS_NAMES: Array<Enum> = [
  {
    id: 'active',
    title: 'Active',
  },
  {
    id: 'inactive',
    title: 'Inactive',
  },
]

export const SET_ASIDE_CODES: Array<string> = [
  '8A',
  '8AN',
  'BICiv',
  'EDWOSB',
  'EDWOSBSS',
  'ESB',
  'HZC',
  'HZS',
  'IEE',
  'ISBEE',
  'LAS',
  'SBA',
  'SBP',
  'SDVOSBC',
  'SDVOSBS',
  'VSA',
  'VSS',
  'WOSB',
  'WOSBSS',
]

export const SET_ASIDE_MAP: Record<string, string> = {
  '8A': '8(a) Set-Aside (FAR 19.8)',
  '8AN': '8(a) Sole Source (FAR 19.8)',
  BICiv:
    'Buy Indian Set-Aside (specific to Department of Health and Human Services, Indian Health Services)',
  EDWOSB:
    'Economically Disadvantaged WOSB (EDWOSB) Program Set-Aside (FAR 19.15)',
  EDWOSBSS:
    'Economically Disadvantaged WOSB (EDWOSB) Program Sole Source (FAR 19.15)',
  ESB: 'Emerging Small Business Set-Aside',
  HZC: 'Historically Underutilized Business (HUBZone) Set-Aside (FAR 19.13)',
  HZS: 'Historically Underutilized Business (HUBZone) Sole Source (FAR 19.13)',
  IEE: 'Indian Economic Enterprise (IEE) Set-Aside (specific to Department of Interior)',
  ISBEE:
    'Indian Small Business Economic Enterprise (ISBEE) Set-Aside (specific to Department of Interior)',
  LAS: 'Local Area Set-Aside (FAR 26.2)',
  SBA: 'Total Small Business Set-Aside (FAR 19.5)',
  SBP: 'Partial Small Business Set-Aside (FAR 19.5)',
  SDVOSBC:
    'Service-Disabled Veteran-Owned Small Business (SDVOSB) Set-Aside (FAR 19.14)',
  SDVOSBS:
    'Service-Disabled Veteran-Owned Small Business (SDVOSB) Sole Source (FAR 19.14)',
  VSA: 'Veteran-Owned Small Business Set-Aside (specific to Department of Veterans Affairs)',
  VSS: 'Veteran-Owned Small Business Sole Source (specific to Department of Veterans Affairs)',
  WOSB: 'Women-Owned Small Business (WOSB) Program Set-Aside (FAR 19.15)',
  WOSBSS: 'Women-Owned Small Business (WOSB) Program Sole Source (FAR 19.15)',
}

export const BUYER_TYPE_TO_DISPLAY: Map<BuyerType, string> = new Map([
  ['DEPARTMENT_AGENCY', 'Department/Ind. Agency'],
  ['SUB_TIER', 'Sub-Tier'],
])
